import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { DurchsuchenQueryFilterConfig, IDurchsuchenQueryShapes, IDurchsuchenResponse } from 'fa-kt.types';
import { DurchsuchenService } from '../service';

@Component({
  selector: 'fa-kt-durchsuchen-filter',
  templateUrl: './durchsuchen-filter.component.html',
  styleUrls: ['./durchsuchen-filter.component.css'],
})
export class DurchsuchenFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public DurchsuchenFilterConfig: IFilterConfig<IDurchsuchenResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public durchsuchen: DurchsuchenService,
  ) {
    this.DurchsuchenFilterConfig = DurchsuchenQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.durchsuchen.shapes$.subscribe((shapes: IDurchsuchenQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.DurchsuchenFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.DurchsuchenFilterConfig[index].selections = shapes;
  }
}
